import { useState } from "react";

import CapsuleDrawer from "~/components/CapsuleDrawer/CapsuleDrawer.jsx";
import LinkArrowSymbol from "~/assets/link-arrow-symbol.svg";

import "./CapsuleCard.css";

const CapsuleCard = ({ data, product, variant, handleQuantityChange, quantity, totalItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div key={product.productPlatformId} className="capsule-card">
      <LinkArrowSymbol onClick={toggleDrawer} className="link-arrow-symbol" />
      <CapsuleDrawer
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
        product={product}
        variant={variant}
      />

      <img src={product.productImageSrc} alt={product.productTitle} />
      <h3 className="capsule-card-product-title">{product.productTitle}</h3>
      <span className="capsule-card-variant-title">{variant.productVariantTitle}</span>
      <span className="capsule-card-price">
        {data.DynamicBox.currencyCode === "USD" ? "$" : ""}
        {variant.price}
      </span>
      <div className="quantity-selector">
        <button
          className="minus"
          onClick={() => handleQuantityChange(product, variant, Math.max(quantity - 1, 0))}
          disabled={quantity === 0}>
          -
        </button>
        <span className="quantity">{quantity}</span>
        <button
          className="plus"
          onClick={() => handleQuantityChange(product, variant, quantity + 1)}
          disabled={totalItems >= 8 && quantity === 0}>
          +
        </button>
      </div>
    </div>
  );
};

export default CapsuleCard;
